import $ from "jquery";

export class Channel {
    constructor(
        private readonly className: string,
        private readonly elementGetter: () => JQuery<HTMLElement>
    ) {}

    write = (text: string) => {
        const span = $('<span class="' + this.className + '"></span>');
        span.text(text);
        this.elementGetter().append(span);
    };

    writeLine = (text: string) => {
        const lines = text.toString().split("\n");

        lines.forEach(line => {
            if (line === "") {
                this.elementGetter().append($("<br>"));
            } else {
                const newLine = $('<div class="' + this.className + '"></div>');
                newLine.text(line);
                this.elementGetter().append(newLine);
            }
        });
    };

    writeObject = (obj: any) => {
        const pre = $('<pre style="background-color: inherit" class="' + this.className + '"></pre>');
        pre.text(JSON.stringify(obj, null, 2));
        this.elementGetter().append(pre);
    };

    writePreFormatted = (text: string) => {
        const pre = $('<pre style="background-color: inherit" class="' + this.className + '"></pre>');
        pre.text(text);
        this.elementGetter().append(pre);
    };
}

export default class Writer {
    $mixedLine: JQuery<HTMLElement>;

    elementGetter = () => {
        return this.$mixedLine ? this.$mixedLine : this.$elementHandle;
    };

    constructor(private readonly $elementHandle: JQuery<HTMLElement>) {}

    output = new Channel("dash-command-output", this.elementGetter);
    error = new Channel("dash-command-error", this.elementGetter);
    help = new Channel("dash-command-help", this.elementGetter);
    command = new Channel("dash-command-info", this.elementGetter);

    clear = () => {
        this.$elementHandle.empty();
    };

    dump = () => {
        return this.$elementHandle.html();
    };

    beginMixed = () => {
        this.$mixedLine = $("<div></div>");
    };

    endMixed = () => {
        if (this.$mixedLine) {
            this.$elementHandle.append(this.$mixedLine);
            this.$mixedLine = undefined;
        }
    };
}
